import { useContext } from 'react';
import { ShopCartContext } from '../context';

export function useShopCart() {
  const { shopCart, setShopCart } = useContext(ShopCartContext);
  return [shopCart, setShopCart] as const;
}
export default useShopCart;
